import { render, staticRenderFns } from "./SearchItemRelation.vue?vue&type=template&id=36d183aa"
import script from "./SearchItemRelation.vue?vue&type=script&lang=js"
export * from "./SearchItemRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports